import { Component, Input, OnInit } from '@angular/core';
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';
import { forkJoin } from 'rxjs';
import { AppRole } from 'src/app/common/constants/app-role.constant';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import { HistoricoTransacoesRealizadasView } from 'src/app/model/view/HistoricoTransacoesReralizadasView';
import { AditivoService } from 'src/app/services/aditivo.service';
import { PacService } from 'src/app/services/pac.service';

@Component({
  selector: 'app-informacoes-de-aditivos',
  templateUrl: './informacoes-de-aditivos.component.html',
  styleUrls: ['./informacoes-de-aditivos.component.scss'],
  standalone: false
})
export class InformacoesDeAditivosComponent implements OnInit{

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  usuario: Usuario;
  aditivos: any[]
  historicos: HistoricoTransacoesRealizadasView[]
  exibirHistorico: boolean = true;
  isExibirComentarioAnaliseAditivo: boolean = true;

  constructor(private aditivoService: AditivoService,
              private pacService: PacService,
              private usuarioService: BnUsuarioService) { }

  ngOnInit(): void {
    this.usuarioService.usuario$.subscribe(
      (usuario: Usuario) => {
        this.usuario = usuario;
        this.definePermisoes();
      });

      this.pacService.buscarAditivo(this.documentoPac.id)
                          .subscribe(response => {
                            this.aditivos = response.length === 0 ? undefined : response

                            if(this.aditivos){
                              this.aditivos.forEach(a => {
                                
                                if(a.aprovacao !== undefined){
                                  forkJoin({
                                    hist: this.pacService.buscarHistorico(a.id, "ADITIVO"),
                                    analise: this.aditivoService.buscarAnaliseAditivo(a.id.toString()),
                                    avisosFluxoAprovacao: this.aditivoService.obterAvisosFluxoAprovacao(a.id.toString())
                                  }).subscribe(resultado => {
                                    a.historico = resultado.hist
                                    a.comentarioAnalise = resultado.analise
                                    a.avisosFluxoAprovacao = resultado.avisosFluxoAprovacao.list
                                  })
                                  

                                  // this.aditivoService.obterAvisosFluxoAprovacao(a.id.toString()).subscribe(resultado => {
                                  //   a.avisosFluxoAprovacao = resultado.list
                                  // })
                                }
                              })
                            }
                          })
  }

  private definePermisoes(){
    if(this.usuario.possuiPermissao(AppRole.AGENTE_FINANCEIRO)){
        this.isExibirComentarioAnaliseAditivo = false;
    } 
}

}

